import Axios from "axios";
import { WebFramework, getDomain } from "../../../Utilities/utils";
import { PRODUCT_LIST_ENDPOINT } from "../../apiConfig";

export default async function onSubmitForm(values, goldmineAndUserId) {
  console.log("Submit values", values);
  console.log("Goldmine and User ID", goldmineAndUserId);

  const userId = goldmineAndUserId.split(":")[0];
  const goldmineId = goldmineAndUserId.split(":")[1];

  // Modify the insureds array to remove objects where relationship_with_proposer is an empty string (if add member button got clicked but no member selected)
  if (values.insureds && Array.isArray(values.insureds)) {
    values.insureds = values.insureds.filter((insured) => {
      return insured.relationship_with_proposer !== "";
    });
  }

  /* Final object with quick quote form values + goldmine id + user id */
  const finalReqBody = {
    ...values,
    goldmineId: goldmineId,
    userId: userId,
  };

  console.log("Final request body", finalReqBody);
  // console.log(
  //   "host",
  //   window.location.hostname,
  //   typeof window.location.hostname
  // );

  // Get the domain based on the web framework based on the localhost, uat or production
  let domain = getDomain(WebFramework.DJANGO);

  console.log("domain", domain);

  try {
    const response = await Axios.post(
      `${domain}${PRODUCT_LIST_ENDPOINT}/`,
      JSON.stringify(finalReqBody)
    );
    if (response.status === 200) {
      return response.data;
    }
    // else if (Object.keys(response.data).length === 0) {
    //   alert("Sorry We don't have any matching Products");
    // }
  } catch (error) {
    console.log("onSubmitForm Error", error);
  }

  return null;
}
